import ProfileImage from '../../../assets/img/testimonial/profile.jpg';

export default function TestimonialSection() {
  return (
    <div>
      <section className="padding-tb-50px sm-ptb-30px bg-baby-pink baby-pink-wave" id="testimonial">
        <div className="container wow fadeInUp" data-wow-duration="1.5s" data-wow-offset="10">
          <div className="row justify-content-center">
            <div className="col-lg-10">
              <div
                className="firo-title dark text-center wow zoomIn margin-bottom-0px margin-top-20px"
                data-wow-delay="0.2s"
              >
                <h2 className="title">What our achiever say</h2>
              </div>
            </div>
          </div>
          <div className="padding-40px padding-sm-10px">
            <div className="row justify-content-center">
              <div className="col-lg-12">
                <div className="slider-1 owl-carousel owl-theme">
                  <div className="testimonial-item layout-1">
                    <div className="img-out">
                      <img src={ProfileImage} alt="Preey Shah" />
                    </div>
                    <div className="content">
                      ""My son likes the classes at Navira Live. It has given him greater exposure
                      to his scientific and mathematical temperament. The teachers explain all the
                      topics and subtopics in detail. They are ready to answer any queries from even
                      from outside the syllabus. It has helped my son in “TIMES NIE THINK AND LEARN
                      CHALLENGE” in which he scored 124’th rank among over 1.5 Lakh students.""
                    </div>
                    <div className="meta">
                      <h4> Sundar</h4>
                      <h5>
                        1st in NSEP <br />
                        (National State Standard Examination in Physics)
                      </h5>
                    </div>
                  </div>
                  <div className="testimonial-item layout-1">
                    <div className="img-out">
                      <img src={ProfileImage} alt="Shrutsh Patil" />
                    </div>
                    <div className="content">
                      ""Faculties are friendly and responsible. They guide my child in proper way.
                      My daughter is very much interested studying here and we are totally
                      satisfied. I hope she will come up higher marks and excellent performance."
                    </div>
                    <div className="meta">
                      <h4>Hari Krishnan</h4>
                      <h5>
                        1st in <br />
                        (Junior Science )
                      </h5>
                    </div>
                  </div>
                  <div className="testimonial-item layout-1">
                    <div className="img-out">
                      <img src={ProfileImage} alt="Mihir Kavishwar" />
                    </div>
                    <div className="content">
                      ""My son has really learnt a lot. The faculties are very good in teaching and
                      really a worth one. We are happy while seeing his development in the recent
                      past.""
                    </div>
                    <div className="meta">
                      <h4>Sharmila</h4>
                      <h5>
                        1st in RMO(Thanjavur)
                        <br />
                        (Regional Math Olympiad)
                      </h5>
                    </div>
                  </div>
                  <div className="testimonial-item layout-1">
                    <div className="img-out">
                      <img src={ProfileImage} alt="Shubhangi Dhanjita" />
                    </div>
                    <div className="content">
                      <strong>
                        "We have enrolled our son with Navira Live program to understand and learn
                        the subjects rather than gulping them. We see him developing interests in
                        his studies after joining First Bench. We hope this keeps on increasing as
                        he moves on to higher standards.
                      </strong>
                    </div>
                    <div className="meta">
                      <h4>Aravind</h4>
                      <h5>1st in Physics </h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
